




// Vue
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

// Third party
import dayjs from 'dayjs';
import 'dayjs/locale/es';

// Constants
import Assets from '@/constants/assets.ts';
import Constants from '@/constants/constants.ts';

// Components
import Checkbox, {
  CheckboxPredefinedStyle,
} from '@/shared/components/checkbox.component.vue';

// Models
import { Convocation } from '@/manager/convocation/convocation.model';

// Filters
import formatDate from '@/shared/filters/formatDate.filter.ts';

import SpotlightText, {
  SpotlightTextColor,
  SpotlightTextBorderType
} from '@/shared/components/SpotlightText.component.vue';

@Component({
  components: {
    Checkbox,
    SpotlightText
  },
  computed: {
    ...mapGetters({
      selectedConvocations: 'getCurrentBudgetAcceptanceSelectedConvocations',
      getAcquiredCourse: 'getAcquiredCourse',
      getConvocation: "getConvocation",
    }),
  },
  filters: {
    formatDate,
  },
})
export default class ChooseConvocation extends Vue {
  @Prop() private product!: any;
  @Prop() private convocationList!: any[];
  @Prop() private inPackList!: string;
  @Prop({ default: false }) private squared!: boolean;

  private assets = Assets;
  private getAcquiredCourse!: any;
  private selectedConvocations!: any;
  private literals = {
    onlyTeachDelegation: 'Esta convocatoria solo se celebra en:',
    notConfirmed: 'Fecha sin confirmar',
    productTaken: 'Ya cursado',
  };
  private pack:any = null;
  private packs: any = null;
  private getConvocation!: any;
  private showingError = false;
  private spotlightTextColor = SpotlightTextColor;
  private spotlightTextBorderType = SpotlightTextBorderType;
  private errorMessage = "";

  get productLevel() {
    let level = '';
    if (
      this.product.level !== null &&
      this.product.level <= '3' &&
      this.product.formativeBranch !== null
    ) {
      level = `N.${this.product.level}`;
    }
    return level;
  }

  get isAcquiredCourse() {
    return this.acquiredCourse && this.convocationList.length === 0;
  }

  get acquiredCourse() {
    return this.getAcquiredCourse(this.product.id);
  }

  get acquiredCourseParticipant() {
    return this.acquiredCourse.participants[0];
  }

  get acquiredCourseIsTaken() {
    const date = this.acquiredCourseParticipant.date;
    return dayjs(date) < dayjs();
  }

  get onlyTeachDelegationProduct() {
    return this.product.onlyTeachDelegation.length > 0;
  }

  private created() {
    this.$store.dispatch('fetchBudgetProductsPack', { id: this.inPackList }).then((res) => {
      this.pack = res.filter((pack: any) => {
        return pack.product === this.product.id;
      })
      this.packs = res;
    })
  }

  private convocationSelected(convocation: any) {
    return (
      this.selectedConvocations.find((convocationId: string) => {
        return convocationId === convocation.id;
      }) !== undefined
    );
  }

  private checkboxClick(convocation: any) {
    if (this.isAcquiredCourse && this.acquiredCourseIsTaken) {
      return
    }

    if (this.pack.length > 0 && (this.pack[0].position || this.pack[0].maxPosition || this.pack[0].deletePosition)) {
      var selectedConvocations: any[] = [];
      this.selectedConvocations.forEach((convocationIds: any) => {
        this.$store.dispatch("fetchConvocation", { id: convocationIds }).then(
          res => {
            if (res.product.id !== convocation.product.id) {
              selectedConvocations.push(res);
            }
          }
        );
      })
      selectedConvocations.push(convocation)
      var newSelectConvocations: any[] = [];
      setTimeout(() => {
        newSelectConvocations = selectedConvocations.sort((a: any, b: any) => Date.parse(a.timetables[0].date) - Date.parse(b.timetables[0].date));
        if (this.pack[0].position) {
          if ((newSelectConvocations.map(function (e) { return e.id; }).indexOf(convocation.id) + 1) == this.pack[0].position) {
            if (!this.convocationSelected(convocation)) {
              this.selectConvocation(convocation);
            }
          }
        } else if (this.pack[0].maxPosition) {
          if ((newSelectConvocations.map(function (e) { return e.id; }).indexOf(convocation.id) + 1) <= this.pack[0].maxPosition) {
            if (!this.convocationSelected(convocation)) {
              this.selectConvocation(convocation);
            }
          }
        } else if (this.pack[0].deletePosition) {
          if ((newSelectConvocations.map(function (e) { return e.id; }).indexOf(convocation.id) + 1) != this.pack[0].deletePosition) {
            if (!this.convocationSelected(convocation)) {
              this.selectConvocation(convocation);
            }
          }
        }
      }, 1000);
    } else {
      var selectedConvocations: any[] = [];
      this.selectedConvocations.forEach((convocationIds: any) => {
        this.$store.dispatch("fetchConvocation", { id: convocationIds }).then(
          res => {
            if (res.product.id !== convocation.product.id) {
              selectedConvocations.push(res);
            }
          }
        );
      })
      selectedConvocations.push(convocation)
      setTimeout(() => {
        let stop = false;
        newSelectConvocations = selectedConvocations.sort((a: any, b: any) => Date.parse(a.timetables[0].date) - Date.parse(b.timetables[0].date));
        this.packs.forEach((pack: any, index: any) => {
          newSelectConvocations.forEach((convocation2, index2) => {

            if (convocation2.product.id == pack.product) {
              if (pack.position) {
                if ((newSelectConvocations.map(function (e) { return e.id; }).indexOf(convocation2.id) + 1) != pack.position) {
                  stop = true;
                  this.showingError = true;
                  this.errorMessage = "Fallo en el orden de la selección: " + ' ' + convocation2.product.name;
                  setTimeout(() => {
                    this.showingError = false;
                  }, 6000);
                  return;
                }
              } else if (pack.maxPosition) {
                if ((newSelectConvocations.map(function (e) { return e.id; }).indexOf(convocation2.id) + 1) >= pack.maxPosition) {
                  stop = true;
                  this.showingError = true;
                  this.errorMessage = "Fallo en el orden de la selección: " + ' ' + convocation2.product.name;
                  setTimeout(() => {
                    this.showingError = false;
                  }, 6000);
                  return;
                }
              } else if (pack.deletePosition) {
                if ((newSelectConvocations.map(function (e) { return e.id; }).indexOf(convocation2.id) + 1) == pack.deletePosition) {
                  stop = true;
                  this.showingError = true;
                  this.errorMessage = "Fallo en el orden de la selección:" + ' ' + convocation2.product.name;
                  setTimeout(() => {
                    this.showingError = false;
                  }, 6000);
                  return;
                }
              }
            }
            if (index == this.packs.length - 1 && index2 == newSelectConvocations.length - 1 && !stop) {
              if (!this.convocationSelected(convocation)) {
                this.selectConvocation(convocation);
              }
            }
          })
        });
      }, 1000);


      if (this.packs.length == 0 && !this.convocationSelected(convocation)) {
        this.selectConvocation(convocation);
      }
    }

  }

  private previousConvocationSelectedList(convocationList: string[]) {
    this.$store.dispatch(
      'setCurrentBudgetAcceptancePreviousConvocationList',
      convocationList,
    );
  }

  private selectConvocation(convocationClicked: any) {
    this.previousConvocationSelectedList(this.selectedConvocations);

    const selectedConvocation = this.convocationList.find(
      (convocation: any) => {
        return this.convocationSelected(convocation);
      },
    );

    if (!selectedConvocation) {
      console.warn('client/budget/views/acceptance/choose-fees/choose-convocation/index.vue say: selectedConvocation is undefined')
    }

    const convocationsFiltered = this.selectedConvocations.filter(
      (convocation: string) => {
        const { id } = selectedConvocation || convocationClicked;
        return convocation !== id;
      },
    );

    convocationsFiltered.push(convocationClicked.id);
    const payload = {
      convocationTouch: convocationClicked.id,
      convocations: convocationsFiltered,
    };
    this.setAcceptanceConvocationList(payload);
  }

  private delegationName(convocation: Convocation) {
    let name = convocation.delegation!.name;
    if (convocation.openDelegation) {
      name = Constants.delegationNotConfirmed;
    }
    return name;
  }

  private setAcceptanceConvocationList(convocationList: any) {
    this.$store.dispatch(
      'setCurrentBudgetAcceptanceConvocationList',
      convocationList,
    );
  }
}
